// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__Jpg25","label":"LabeledBox_label__3bvrB"};